import { FlexContainer, IconMessage } from '@act/storybook';
import { Typography } from '@mui/material';

/**
 * Shown when the acting user lacks {@link Permission.CAN_VIEW_REPORTS}.
 */
const ReportsUnauthorized = () => {
  return (
    <FlexContainer
      direction="column"
      alignItems="center"
      justifyContent="center"
      padding={4}
      width="100%"
      height="100%"
    >
      <FlexContainer direction="column" alignItems="center" gap={2} maxWidth="480px">
        <IconMessage
          message="Access denied"
          subMessage="You do not have permission to view customer reports. Contact your administrator if you believe this is a mistake."
          iconName="Prohibit"
          iconColor="error"
        />
        <Typography variant="body2" color="text.secondary" align="center">
          Required permission: CAN_VIEW_REPORTS
        </Typography>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ReportsUnauthorized;
